/** Keep 2 decimal places without rounding. 103.488 becomes 103.48, not 103.49. */
export function truncateMoney(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return 0;
  const sign = amount < 0 ? -1 : 1;
  const formatted = Math.abs(amount).toFixed(8);
  const [whole, frac = "00"] = formatted.split(".");
  return sign * Number(`${whole}.${(frac + "00").slice(0, 2)}`);
}
